module.exports = __webpack_public_path__ + "static/dairyfarm-44109cc61845d5c57cd02b2ea71990d6.jpg";